module.exports = __webpack_public_path__ + "fonts/icons.woff2"


/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-css/themes/default/assets/fonts/icons.woff2
 ** module id = 385
 ** module chunks = 0
 **/